import { deeps } from '@/mocks/chigua';

export default function DeepDive() {
  return (
    <section id="deep" className="scroll-mt-16 bg-paper-100/70 py-12 md:py-16">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <div className="flex flex-col gap-4 sm:flex-row sm:items-end sm:justify-between">
          <div>
            <div className="flex items-center gap-2">
              <span className="font-heading text-sm font-bold tracking-widest text-accent-700">深度解析 · 关键看点</span>
              <span className="h-px w-8 bg-accent-400" />
            </div>
            <h2 className="mt-2 font-heading text-2xl font-bold text-ink-900 md:text-3xl">
              四个角度，把「热闹」拆成「门道」
            </h2>
          </div>
          <p className="max-w-sm text-sm leading-relaxed text-ink-500">
            不做情绪宣泄，只做结构与利益分析。每一段推论都可回溯到前面章节的证据。
          </p>
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 lg:grid-cols-2">
          {deeps.map((d) => (
            <article
              key={d.num}
              className="group flex cursor-pointer gap-4 rounded-lg border border-paper-200 bg-paper-50 p-5 transition-all hover:border-accent-300 md:gap-5 md:p-6"
            >
              <span className="font-heading text-3xl font-bold leading-none text-paper-300 transition-colors group-hover:text-accent-300 md:text-4xl">
                {d.num}
              </span>
              <div className="min-w-0">
                <div className="flex items-center gap-2">
                  <span className="rounded-full bg-accent-100 px-2.5 py-0.5 text-xs font-semibold text-accent-700">
                    {d.angle}
                  </span>
                </div>
                <h3 className="mt-2 font-heading text-lg font-bold leading-snug text-ink-900 transition-colors group-hover:text-accent-700">
                  {d.title}
                </h3>
                <p className="mt-2 text-[13px] leading-[1.85] text-ink-600">{d.body}</p>
                <div className="mt-3 flex items-center gap-1.5 text-sm font-medium text-accent-600">
                  展开完整解析
                  <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}